import { connectAuthEmulator, getAuth } from "firebase/auth";
import { firebase } from "./firebase";
import { config } from "@/config";

const auth = getAuth(firebase);

if (config.emulator) {
  connectAuthEmulator(auth, "http://localhost:9099");
}

const getToken = async () => await auth.currentUser?.getIdToken();

export { auth, getToken };
